<template>
  <div class="content">
    <div class="navTabBar">
      <div
        v-for="(item, index) in navList"
        :key="index"
        class="nav-item"
        :class="{ current: tabCurrentIndex === index }"
        @click="tabClick(index)"
      >
        {{ item.text }}
        <span class="num" v-if="item.state == 5 && virtualStatusNum.invitationNum>0">{{virtualStatusNum.invitationNum}}</span>
        <span class="num" v-if="item.state == 1 && virtualStatusNum.prePayNum>0">{{virtualStatusNum.prePayNum}}</span>
        <span class="num" v-if="item.state == 2 && virtualStatusNum.preDeliveryNum > 0">{{virtualStatusNum.preDeliveryNum}}</span>
      </div>
    </div>

    <van-swipe
      width="100%"
      :initial-swipe="tabCurrentIndex"
      :autoplay="0"
      class="van-swiper-box"
      duration="300"
      @change="changeTab"
      :loop="false"
      :show-indicators="false"
    >
      <van-swipe-item
        class="tab-content"
        v-for="(tabItem, tabIndex) in navList"
        :key="tabIndex"
      >
        <my-refresh-more
          :ref="'refresh_' + tabItem.state"
          class="list-scroll-content"
          :params="{ state: tabItem.state }"
          :pageSize="10"
          v-model="tabItem.orderList"
          :getList="getList"
        >
          <!-- 订单列表 -->
          <div
            slot="list"
            v-for="(item, index) in tabItem.orderList"
            :key="index"
            class="order-item"
            @click="clickOrder(index)"
          >
            <div class="i-top b-b">
              <div class="flex-1">
                <van-tag
                  v-if="
                    item.groupBuyState != null &&
                    item.groupBuyState != undefined
                  "
                  type="danger"
                  >{{
                    item.groupBuyState == 0
                      ? "拼购中"
                      : item.groupBuyState == 1
                      ? "拼购成功"
                      : "拼购失败"
                  }}</van-tag
                >
                <span class="time">{{ item.createTime }}</span>
              </div>
              <span class="state" :style="{ color: item.stateTipColor }">{{
                item.stateTip
              }}</span>
              <span
                v-if="item.status === 7"
                class="del-btn yticon icon-iconfontshanchu1"
                @click.stop="deleteOrder(index)"
              ></span>
            </div>

            <div v-if="item.orderItems.length > 1" class="goods-box">
              <div
                v-for="(goodsItem, goodsIndex) in item.orderItems"
                :key="goodsIndex"
                class="goods-item"
              >
                <van-image
                  lazy-load
                  class="goods-img"
                  width="80"
                  height="80"
                  :src="goodsItem.productPic"
                  mode="aspectFill"
                ></van-image>
              </div>
            </div>
            <div
              v-if="item.orderItems.length === 1"
              class="goods-box-single"
              v-for="(goodsItem, goodsIndex) in item.orderItems"
              :key="goodsIndex"
            >
              <van-image
                lazy-load
                class="goods-img"
                width="80"
                height="80"
                :src="goodsItem.productPic"
                mode="aspectFill"
              ></van-image>
              <div class="right">
                <span class="title clamp">{{ goodsItem.productName }}</span>
                <span class="attr-box"
                  >{{ goodsItem.productSpec }} x {{ goodsItem.quantity }}</span
                >
                <span class="price">{{ goodsItem.price }}</span>
              </div>
            </div>

            <div class="price-box">
              共
              <span class="num">{{ item.orderItems.length }}</span>
              件商品 实付款
              <span class="price">{{ item.needPayPrice }}</span>
            </div>
          </div>
        </my-refresh-more>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabCurrentIndex: 0,
      virtualStatusNum:'',
      navList: [
        {
          state: 0,
          text: "全部",
          orderList: [],
        },
        {
          state: 5,
          text: "待成团",
          orderList: [],
        },
        {
          state: 1,
          text: "待付款",
          orderList: [],
        },
        {
          state: 2,
          text: "待核销",
          orderList: [],
        },
        {
          state: 4,
          text: "已核销",
          orderList: [],
        },
      ],
    };
  },

  created() {
    let query = this.$route.query;
    if (query.state == 5) {
      this.tabCurrentIndex = 1;
    } else {
      this.tabCurrentIndex = query.state ? query.state * 1 + 1 : 0;
    }
    this.init()
  },

  methods: {
    init() {
       this.$http
        .request(this.$http.pathMap.virtualStatusNum, "get").then(res => {
          this.virtualStatusNum = res.data
        })
    },
    getList(page, pageSize, param) {
      let params = {
        page: page,
        size: pageSize,
      };
      if (param.state) {
        params.status = param.state;
        if (param.state == 5) {
          params.status = 2;
          params.groupBuyState = 0;
        }
      }
      let that = this;
      return new Promise((resolve, reject) => {
        that.$http
          .request(that.$http.pathMap.orderVirtualList, "get", params)
          .then((res) => {
            let data = res.data;
            data.list.forEach((item) => {
              let orderState = "";
              if (item.groupBuyState == 0) {
                orderState = that.orderStateExp(6);
              } else {
                orderState = that.orderStateExp(item.status);
              }

              item.stateTip = orderState.stateTip;
              item.stateTipColor = orderState.stateTipColor;
            });
            resolve(data);
          });
      });
    },

    //swiper 切换
    changeTab(index) {
      this.tabCurrentIndex = index;
    },
    //顶部tab点击
    tabClick(index) {
      this.tabCurrentIndex = index;
      let order = this.navList[this.tabCurrentIndex].orderList[index];
      let state = this.navList[this.tabCurrentIndex].state;
      let re = "refresh_" + state;
      this.$refs[re][0].refreshList();
    },
    //删除订单
    deleteOrder(index) {
      let order = this.navList[this.tabCurrentIndex].orderList[index];
      let state = this.navList[this.tabCurrentIndex].state;
      this.$http
        .request(this.$http.pathMap.orderDeleted + "/" + order.orderId, "get")
        .then((res) => {
          let re = "refresh_" + state;
          this.$refs[re][0].refreshList();
        });
    },
    clickOrder(index) {
      let order = this.navList[this.tabCurrentIndex].orderList[index];
      this.$router.push({
        path: "/pages/order/orderDetail",
        query: {
          orderId: order.orderId,
          type: "virtual",
        },
      });
    },
    //取消订单
    cancelOrder(index) {
      let order = this.navList[this.tabCurrentIndex].orderList[index];
      let state = this.navList[this.tabCurrentIndex].state;
      this.$http
        .request(this.$http.pathMap.orderCancel + "/" + order.orderId, "get")
        .then((res) => {
          let re = "refresh_" + state;
          this.$refs[re].refreshList();
        });
    },

    //订单状态文字和颜色
    orderStateExp(state) {
      let stateTip = "",
        stateTipColor = "#fa436a";
      switch (state) {
        case 1:
          stateTip = "待付款";
          break;
        case 2:
          stateTip = "待核销";
          break;
        case 4:
          stateTip = "已核销";
          break;
        case 5:
          stateTip = "交易关闭";
          break;
        case 6:
          stateTip = "待成团";
          break;
      }
      return {
        stateTip,
        stateTipColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
page,
.content {
  background: $page-color-base;
  height: 100%;
}

.van-swiper-box {
  height: calc(100% - 40px);
}

.list-scroll-content {
  height: 100%;
  overflow-y: scroll;
}

.navTabBar {
  display: flex;
  height: 40px;
  padding: 0 5px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 10;

  .nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 15px;
    color: $font-color-dark;
    position: relative;
    .num {
      position: absolute;
      top: 2px;
      right: 10px;
      height: 15px;
      min-width: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 25px;
      padding: 2px;
      color: white;
      font-size: $uni-font-size-sm;
      background-color: var(--theme-font-color);
    }
    &.current {
      color: $base-color;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 44px;
        height: 0;
        border-bottom: 2px solid $base-color;
      }
    }
  }
}

.uni-swiper-item {
  height: auto;
}

.order-item {
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  background: #fff;
  margin-top: 8px;

  .i-top {
    display: flex;
    align-items: center;
    height: 40px;
    padding-right: 15px;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
    position: relative;

    .time {
      margin-left: 5px;
      flex: 1;
    }

    .state {
      color: $base-color;
    }

    .del-btn {
      padding: 5px 0 5px 18px;
      font-size: $uni-font-size-lg;
      color: $font-color-light;
      position: relative;

      &:after {
        content: "";
        width: 0;
        height: 15px;
        border-left: 1px solid $uni-border-color-dark;
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  /* 多条商品 */
  .goods-box {
    height: 100px;
    padding: 10px 0;
    white-space: nowrap;

    .goods-item {
      width: 80px;
      height: 80px;
      display: inline-block;
      margin-right: 12px;
    }

    .goods-img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  /* 单条商品 */
  .goods-box-single {
    display: flex;
    padding: 10px 0;

    .goods-img {
      display: block;
      width: 80px;
      height: 80px;
    }

    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 15px 0 12px;
      overflow: hidden;

      .title {
        font-size: $uni-font-size-base + 1px;
        color: $font-color-dark;
        line-height: 1;
      }

      .attr-box {
        font-size: $uni-font-size-sm + 1px;
        color: $font-color-light;
        padding: 5px 6px;
      }

      .price {
        font-size: $uni-font-size-base + 1px;
        color: $font-color-dark;

        &:before {
          content: "￥";
          font-size: $uni-font-size-sm;
          margin: 0 1px 0 4px;
        }
      }
    }
  }

  .price-box {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    padding: 10px 15px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-light;

    .num {
      margin: 0 4px;
      color: $font-color-dark;
    }

    .price {
      font-size: $uni-font-size-lg;
      color: $font-color-dark;

      &:before {
        content: "￥";
        font-size: $uni-font-size-sm;
        margin: 0 1px 0 4px;
      }
    }
  }

  .action-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 50px;
    position: relative;
    padding-right: 15px;
  }

  .action-btn {
    height: 30px;
    margin: 0;
    margin-left: 12px;
    padding: 0 10px;
    text-align: center;
    line-height: 28px;
    font-size: $uni-font-size-sm + 1px;
    background: #fff;
    border-radius: 100px;
    border: 1px #f8f8f8 solid;

    &:after {
      border-radius: 100px;
    }

    &.recom {
      background: #fff9f9;
      color: $base-color;

      &:after {
        border-color: #f7bcc8;
      }
    }
  }
}

/* load-more */
.uni-load-more {
  display: flex;
  flex-direction: row;
  height: 40px;
  align-items: center;
  justify-content: center;
}

.uni-load-more__text {
  font-size: 14px;
  color: #999;
}

.uni-load-more__img {
  height: 24px;
  width: 24px;
  margin-right: 10px;
}

.uni-load-more__img > div {
  position: absolute;
}

.uni-load-more__img > div div {
  width: 6px;
  height: 2px;
  border-top-left-radius: 1px;
  border-bottom-left-radius: 1px;
  background: #999;
  position: absolute;
  opacity: 0.2;
  transform-origin: 50%;
  animation: load 1.56s ease infinite;
}

.uni-load-more__img > div div:nth-child(1) {
  transform: rotate(90deg);
  top: 2px;
  left: 9px;
}

.uni-load-more__img > div div:nth-child(2) {
  transform: rotate(180deg);
  top: 11px;
  right: 0;
}

.uni-load-more__img > div div:nth-child(3) {
  transform: rotate(270deg);
  bottom: 2px;
  left: 9px;
}

.uni-load-more__img > div div:nth-child(4) {
  top: 11px;
  left: 0;
}

.load1,
.load2,
.load3 {
  height: 24px;
  width: 24px;
}

.load2 {
  transform: rotate(30deg);
}

.load3 {
  transform: rotate(60deg);
}

.load1 div:nth-child(1) {
  animation-delay: 0s;
}

.load2 div:nth-child(1) {
  animation-delay: 0.13s;
}

.load3 div:nth-child(1) {
  animation-delay: 0.26s;
}

.load1 div:nth-child(2) {
  animation-delay: 0.39s;
}

.load2 div:nth-child(2) {
  animation-delay: 0.52s;
}

.load3 div:nth-child(2) {
  animation-delay: 0.65s;
}

.load1 div:nth-child(3) {
  animation-delay: 0.78s;
}

.load2 div:nth-child(3) {
  animation-delay: 0.91s;
}

.load3 div:nth-child(3) {
  animation-delay: 1.04s;
}

.load1 div:nth-child(4) {
  animation-delay: 1.17s;
}

.load2 div:nth-child(4) {
  animation-delay: 1.3s;
}

.load3 div:nth-child(4) {
  animation-delay: 1.43s;
}

@-webkit-keyframes load {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
</style>
